import React, { Component } from 'react';
import { observer, Provider } from 'mobx-react';

import TransactionStore from 'js/stores/pages/AdminDashboardPage/TransactionStore';
import { formatCurrency } from 'js/services/Format';
import { adminPanelColor } from 'js/config/style';

import LoadingSpinner from '../../LoadingSpinner';
import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import DropMenu from '../../DashPanel/DropMenu';

import Modal from 'js/components/core/Modal';
import SubmitRow from 'js/components/core/Modal/SubmitRow';
import Button from 'js/components/common/Button';

import Row from '../../List/Row';
import User from '../../Display/User';
import Order from '../../Display/Order';
import CreditCard from '../../Display/CreditCard';
import BankAccount from '../../Display/BankAccount';
import TransactionDisplay from '../../Display/Transaction';

import Link from './Link';
import Icon from './Icon';
import Title from './Title';
import Text from './Text';
import Tools from './Tools';
import ToolButton from './ToolButton';

import Card from './Card';
import Display from './Display';
import Image from './Image';
import Details from './Details';
import Label from './Label';
import Amount from './Amount';
import Question from './Question';
import TransactionStatus from '../TransactionStatus';
import FinalPrice from "./FinalPrice";
import Table from './Table';
import Th from './Th';
import MobileDetails from './MobileDetails';

@observer
export default class Transaction extends Component {
  transaction = TransactionStore.create({ id: parseInt(this.props['*']) });

  constructor(props) {
    super(props);
    this.transaction.load();
  }

  componentDidUpdate() {
    const id = parseInt(this.props['*']);
    if (this.transaction.id !== id) {
      this.transaction.setId(id).load();
    }
  }

  render() {
    const transaction = this.transaction;
    return (
      <>
        <DashPanel>
          <Header>
            <DropMenu />
            <Title>
              <Link to="/admin-req/admin/transactions">Transactions</Link>
              {transaction.human_description && (
                <>
                  <Icon name="chevron-right" />
                  <Text>{transaction.human_description}</Text>
                </>
              )}
            </Title>
          </Header>

          <Provider model={transaction}>
            <Content background={adminPanelColor}>
              {this.transaction.isLoading ? (
                <LoadingSpinner />
              ) : (
                <>
                  <Card>
                    {transaction.can_void && (
                      <Tools>
                        <ToolButton onClick={transaction.promptVoid}>Void this transaction</ToolButton>
                      </Tools>
                    )}

                    <Display>
                      <Image />
                    </Display>

                    <Details>
                      <Label>Created</Label>
                      <div>{transaction.created_at}</div>

                      <Label>Description</Label>
                      <div>{transaction.human_description}</div>

                      {(this.transaction.description === 'buyer-purchase' || this.transaction.description === 'seller-sale')?(
                        <MobileDetails>
                          <Label>Sale price</Label>
                          <div>
                            <Amount>{formatCurrency(transaction.item_price)}</Amount>
                          </div>

                          <Label>Shipping cost</Label>
                          <div>
                            <Amount>{formatCurrency(transaction.shipping)}</Amount>
                          </div>

                          <Label>POD revenue</Label>
                          <div>
                            <Amount>{formatCurrency(transaction.pod_revenue)}</Amount>
                          </div>

                          <Label>Settlement fee</Label>
                          <div>
                            <Amount>{formatCurrency(transaction.settlement_fee)}</Amount>
                          </div>

                          <Label>Interchange fee</Label>
                          <div>
                            <Amount>{formatCurrency(transaction.interchange_fee)}</Amount>
                          </div>

                          <Label>Credit applied</Label>
                          <div>
                            <Amount>{formatCurrency(transaction.credit_applied)}</Amount>
                          </div>

                          <Label>Margin</Label>
                          <div>
                            <Amount>{formatCurrency(transaction.pod_margin)}</Amount>
                          </div>

                          <Label>Buyer payed</Label>
                          <div>
                            <Amount>{formatCurrency(transaction.buyer_payed)}</Amount>
                          </div>

                          <Label>Seller settlement</Label>
                          <div>
                            <FinalPrice>{formatCurrency(transaction.seller_settlement)}</FinalPrice>
                          </div>
                        </MobileDetails>
                      ):(<></>)}

                      {(this.transaction.description !== 'seller-sale' &&
                        this.transaction.description !== 'buyer-purchase')?(<>
                        <Label>Amount</Label>
                        <div>
                          <FinalPrice>{formatCurrency(transaction.amount)}</FinalPrice>
                        </div>
                      </>):(<></>)}

                      <Label></Label>
                      <div>
                        <TransactionStatus transaction={transaction} />
                      </div>
                    </Details>

                    {(this.transaction.description === 'buyer-purchase' || this.transaction.description === 'seller-sale')?(
                      <Table>
                        <thead>
                        <tr>
                          <Th>Sale price</Th>
                          <Th>Shipping cost</Th>
                          <Th>POD revenue</Th>
                          <Th>Settlement fee</Th>
                          <Th>Interchange fee</Th>
                          <Th>Credit applied</Th>
                          <Th>Margin</Th>
                          <Th>Buyer payed</Th>
                          <Th>Seller settlement</Th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td><Amount>{formatCurrency(transaction.item_price)}</Amount></td>
                          <td><Amount>{formatCurrency(transaction.shipping)}</Amount></td>
                          <td><Amount>{formatCurrency(transaction.pod_revenue)}</Amount></td>
                          <td><Amount>{formatCurrency(transaction.settlement_fee)}</Amount></td>
                          <td><Amount>{formatCurrency(transaction.interchange_fee)}</Amount></td>
                          <td><Amount>{formatCurrency(transaction.credit_applied)}</Amount></td>
                          <td><Amount>{formatCurrency(transaction.pod_margin)}</Amount></td>
                          <td><Amount>{formatCurrency(transaction.buyer_payed)}</Amount></td>
                          <td><Amount>{formatCurrency(transaction.seller_settlement)}</Amount></td>
                        </tr>
                        </tbody>
                      </Table>
                    ):(<></>)}

                  </Card>

                  <div>
                    <Row cols={2}>
                      {transaction.credit_card_id && (
                        <CreditCard load={{ transaction_id: transaction.id }} title="Credit card" />
                      )}
                      {transaction.bank_account_id && (
                        <BankAccount load={{ transaction_id: transaction.id }} title="Bank account" />
                      )}
                      <Order load={{ transaction_id: transaction.id }} title="Order" />
                      {transaction.parent_id && (
                        <TransactionDisplay
                          load={{ transaction_id: transaction.parent_id }}
                          title="Parent transaction"
                        />
                      )}
                      {transaction.void_id && (
                        <TransactionDisplay load={{ transaction_id: transaction.void_id }} title="Void transaction" />
                      )}
                    </Row>

                    <Row cols={2}>
                      <User load={{ transaction_id: transaction.id }} title="User" />
                    </Row>
                  </div>
                </>
              )}
            </Content>
          </Provider>
        </DashPanel>

        <Modal showModal={transaction.showVoidPrompt} onCancel={transaction.closeVoidPrompt} padded withCloseButton>
          <Question>Are you sure you want to void this transaction?</Question>
          <SubmitRow>
            <Button onClick={transaction.voidTransaction} isLoading={transaction.isVoiding}>
              {transaction.isVoiding ? 'Voiding transaction' : 'Void transaction now'}
            </Button>
          </SubmitRow>
        </Modal>
      </>
    );
  }
}
